import {Component, Input, OnInit} from '@angular/core';
import {ChartType} from "chart.js";

@Component({
    selector: 'app-chart',
    templateUrl: './chart.component.html',
    styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit {

    @Input() data;
    @Input() x_key;
    @Input() keys;
    @Input() chart_type: ChartType = 'line';
    @Input() chart_legend;
    @Input() chart_labels: Array<any> = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

    public chart_data: Array<any> = [
        {data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A'},
        {data: [65, 59, 80, 81, 56, 55, 40], label: 'Series B'},
    ];
    public chart_options: any = {};

    constructor() {
    }

    ngOnInit() {
        this.chart_legend = (this.chart_legend === 'true');
        this.chart_options = {
            responsive: true,
            legend: {
                display: this.chart_legend as boolean
            }
        };
        let y_key = '';
        for (let k of this.keys) {
            if (k != this.x_key) {
                y_key = k;
            }
        }
        // this.chart_labels = [];
        for (let item of this.data[0]) {
            this.chart_labels.push(item[this.x_key]);
        }
        let tmp = [];
        for (let item of this.chart_labels) {
            if (typeof item != 'undefined')
                tmp.push(item);
        }
        this.chart_labels = tmp;
        let chart_data: Array<any> = new Array(this.data.length - 1);
        for (let j = 0; j < this.data.length; j++) {
            chart_data[j] = {data: new Array(this.data[j].length), label: y_key + j};
            for (let i = 0; i < this.data[j].length; i++) {
                chart_data[j].data[i] = this.data[j][i][y_key];
            }
        }
        this.chart_data = chart_data;
    }
}
